// import { Component, OnDestroy } from '@angular/core';
// import { Router } from '@angular/router';
// import { Subject } from 'rxjs';

// @Component({
//   selector: 'app-callback',
//   templateUrl: './callback.component.html',
//   styleUrls: ['./callback.component.scss'],
// })
// export class CallbackComponent implements OnDestroy {
//   private onDestroy$ = new Subject<void>();
//   private timeout!: NodeJS.Timeout;

//   constructor(private router: Router) {}

//   ngOnInit() {
//     this.timeout = setTimeout(() => this.navigate(), 5000);
//   }

//   navigate() {
//     this.router.navigate(['/ALMHome']);
//   }

//   ngOnDestroy() {
//     clearTimeout(this.timeout);
//     this.onDestroy$.next();
//     this.onDestroy$.unsubscribe();
//   }
// }

import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    standalone: false
})
export class CallbackComponent implements OnDestroy {
  private onDestroy$ = new Subject<void>();
  private timeout: any;

  constructor(private router: Router) {}

  ngOnInit() {
    this.timeout = setTimeout(() => this.navigate(), 5000);
  }

  navigate() {
    this.router.navigate(['/landing']);
  }

  ngOnDestroy() {
    clearTimeout(this.timeout);
    this.onDestroy$.next();
    this.onDestroy$.unsubscribe();
  }
}
